import * as React from "react";
import "./styles.scss";
import { dummyPlayerCard, PlayerCardTemplate, PlayerCardWidget } from "../../../../services/bedrock";
import { useContext, useEffect, useState } from "react";
import { Button, Pagination, Table } from "semantic-ui-react";
import AddTemplateModal from "./AddTemplateModal";
import PlayerCardTab from "../PlayerCardTab";
import { PlayerCardSettingsContext } from "../../Contexts";
import _ from "lodash";
import PlayerCardTemplateRow from "./PlayerCardTemplateRow";

interface TemplatesTabProps {
  active: boolean;
}

const TemplatesTab: React.FC<TemplatesTabProps> = ({ active }) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false);
  const [templateToDuplicate, setTemplateToDuplicate] = useState<PlayerCardTemplate | undefined>(undefined);

  const { Preview, Templates, User } = useContext(PlayerCardSettingsContext);

  useEffect(() => {
    if (!active || Templates.inEditMode) return;
    if (Templates.selectedTemplate) {
      Preview.setPlayerCard({
        ...dummyPlayerCard,
        widgets: Templates.selectedTemplate.widgets as unknown as PlayerCardWidget[],
      });
    } else {
      Preview.setPlayerCard(undefined);
    }
  }, [active, Templates.selectedTemplate]);

  useEffect(() => {
    if (Templates.inEditMode) return;
    if (!Templates.selectedTemplate || !Templates.templates.find(pc => pc.id === Templates.selectedTemplate!.id)) {
      Templates.setSelectedTemplate(Templates.templates[0]);
    }
  }, [Templates.templates, Templates.inEditMode, Templates.selectedTemplate]);

  const handleEditModalClose = (template?: PlayerCardTemplate) => {
    if (!!template) {
      Templates.handleTemplateUpdated(template);
    }
  };

  const openAddModal = (template?: PlayerCardTemplate) => {
    setTemplateToDuplicate(template);
    setIsAddModalOpen(true);
  };

  if (Templates.inEditMode && Templates.selectedTemplate) {
    return (
      <PlayerCardTab
        active={active}
        playerCard={Templates.selectedTemplate}
        onPlayerCardSaved={playerCard => handleEditModalClose(playerCard as PlayerCardTemplate)}
        onClose={() => Templates.setInEditMode(false)}
      />
    );
  }

  return (
    <div className={`playerCardTemplatesTab ${active ? "active" : ""}`}>
      <AddTemplateModal
        open={isAddModalOpen}
        templateToDuplicate={templateToDuplicate}
        onClose={() => setIsAddModalOpen(false)}
      />
      <Table
        className={`templatesTable ${Templates.isLoading && Templates.templates.length > 0 ? "loading" : ""}`}
        selectable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell width="1" />
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {Templates.isLoading && Templates.templates.length === 0 && (
            <Table.Row>
              <Table.Cell colSpan={2} textAlign="center">
                Loading...
              </Table.Cell>
            </Table.Row>
          )}
          {!Templates.isLoading && Templates.templates.length === 0 && (
            <Table.Row>
              <Table.Cell colSpan={2} textAlign="center">
                You have no templates.
              </Table.Cell>
            </Table.Row>
          )}
          {Templates.templates.map(template => (
            <PlayerCardTemplateRow
              key={template.id}
              template={template}
              isSelected={template.id === Templates.selectedTemplate?.id}
              onDuplicateClick={openAddModal}
            />
          ))}
        </Table.Body>
        {User.hasWritePermission && (
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan={2}>
                <Button primary content="Add Template" onClick={() => openAddModal()} />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
      {Templates.totalPages > 1 && (
        <Pagination
          secondary
          pointing
          activePage={Templates.activePage}
          totalPages={Templates.totalPages}
          firstItem={null}
          lastItem={null}
          onPageChange={(_event, data) => Templates.loadPage(Number(data.activePage))}
        />
      )}
    </div>
  );
};
export default TemplatesTab;
